// SPDX-License-Identifier: AGPL-3.0-or-later

import {hostedImageUrl} from '@app/features/app/config/HostedMedia';

export const BANNED_MP4 = hostedImageUrl('app-banned.57f4a7f02835e746.mp4');
export const BANNED_WEBM = hostedImageUrl('app-banned.7b2a4c17603fbe1c.webm');
export const BANNED_POSTER = hostedImageUrl('app-banned.da3d66d03a7c4962.webp');
